const { createAction } = require('@reduxjs/toolkit');

export const passwordExpired = createAction('app/passwordExpired');
export const requireResetPassword = createAction('app/requireResetPassword');
export const requireAcceptTerms = createAction('app/requireAcceptTerms');
